import { Container, Grid, GridItem, Text, VStack } from '@chakra-ui/react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import Image from '@repo/ui-components/tailwind/Image';
import { useUiComponentsInternationalContext } from '@repo/static-translations';
import { DeptGrid } from '../../../design-system';

export default function AppDownloads({ block }) {
  const { tt } = useUiComponentsInternationalContext();

  return (
    <Container>
      <Text color="typography.base" textStyle="body">
        {tt(s => s.blocksDeptComponents.productManualsPrompt)}{' '}
        <Link
          className="text-foreground underline"
          href="https://support.petsafe.net/s/"
          target="_blank"
        >
          {tt(s => s.blocksDeptComponents.browseProductsLabel)}
        </Link>
      </Text>
      <DeptGrid>
        {block.products?.map(product => (
          <GridItem key={product.productKey} colSpan={{ base: 6, lg: 12 }}>
            <Grid
              templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(4, 1fr)' }}
              gap={{ base: 6, lg: 10 }}
              pb="6"
              borderBottomColor="typography.base"
              borderBottomWidth="2px"
              borderBottomStyle="solid"
            >
              {product.image?.asset?.url && (
                <GridItem colSpan={1}>
                  <Image sanityImage={product.image} width="100%" />
                </GridItem>
              )}
              <GridItem colSpan={3}>
                <VStack align="flex-start" mt="6" mb="6">
                  <Text color="typography.base" textStyle="h3" as="h3">
                    {product.headline}
                  </Text>
                  <Text color="typography.light" textStyle="body">
                    {product.sku}
                  </Text>
                  <Text textStyle="bodyLarge" fontWeight="bold">
                    {tt(s => s.blocksDeptComponents.downloadsLabel)}
                  </Text>
                  {product.links?.map(link => (
                    <Link
                      className="text-foreground underline"
                      href={link.href}
                      key={link._key}
                      target={link.blank && '_blank'}
                    >
                      {link.text}
                    </Link>
                  ))}
                </VStack>
              </GridItem>
            </Grid>
          </GridItem>
        ))}
      </DeptGrid>
    </Container>
  );
}

AppDownloads.propTypes = {
  block: PropTypes.shape({
    products: PropTypes.arrayOf(
      PropTypes.shape({
        productKey: PropTypes.string.isRequired,
        image: PropTypes.shape({
          asset: PropTypes.shape({
            url: PropTypes.string.isRequired,
          }).isRequired,
        }).isRequired,
        headline: PropTypes.string.isRequired,
        sku: PropTypes.string.isRequired,
        links: PropTypes.arrayOf(
          PropTypes.shape({
            _key: PropTypes.string.isRequired,
            href: PropTypes.string.isRequired,
            blank: PropTypes.bool,
            text: PropTypes.string.isRequired,
          })
        ).isRequired,
      })
    ),
  }).isRequired,
};
